const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
	defaults: {
		vaulted: false,
		touchUp: false,
		length: 0,
		width: 0,
		doors: 0,
		windows: 0,
		'gallons-walls': 0,
		'gallons-ceiling': 0,
		'gallons-trim': 0,
		'gallons-doors': 0
	},
	initialize: function() {
		this.listenTo(this, 'change:vaulted', this._onChangeVaulted);
		this.listenTo(this, 'change:touchUp', this._onChangeTouchUp);
		this.listenTo(this, 'change:length', this._onChangeLength);
		this.listenTo(this, 'change:width', this._onChangeWidth);
		this.listenTo(this, 'change:doors', this._onChangeDoors);
		this.listenTo(this, 'change:windows', this._onChangeWindows);

		// Globals from Behr calculator
		this.TOUCHUP_QTY_FACTOR = 1.05;
		this.SPREAD_RATE = 350.0;
		this.VAULTED_CEILING_FACTOR = 1.103377919;
		this.QUART_THRESHOLD = 0.25;
		this.DOOR_SURFACE_AREA = 21.0;
		this.WINDOW_SURFACE_AREA = 20.0;
		this.VAULTED_CEILING_HEIGHT = 12.0;
		this.STANDARD_CEILING_HEIGHT = 9.0;
		this.WINDOW_PERIMETER = 18.0;
	},
	_onChangeVaulted: function(model, value) {
		this._applyChangeBoolean('vaulted', value);
	},
	_onChangeTouchUp: function(model, value) {
		this._applyChangeBoolean('touchUp', value);
	},
	_onChangeLength: function(model, value) {
		this._applyChangeNumber('length', value);
	},
	_onChangeWidth: function(model, value) {
		this._applyChangeNumber('width', value);
	},
	_onChangeDoors: function(model, value) {
		this._applyChangeNumber('doors', value);
	},
	_onChangeWindows: function(model, value) {
		this._applyChangeNumber('windows', value);
	},
	_applyChangeBoolean: function(name, value) {
		const numberValue = Number(value);
		if (numberValue || numberValue === 0) {
			this.set(name, Boolean(numberValue), {
				silent: true
			});
			this._calculateAllQuantities();
		}
	},
	_applyChangeNumber: function(name, value) {
		const numberValue = Number(value);
		if (numberValue || numberValue === 0) {
			this.set(name, Math.max(numberValue, 0), {
				silent: true
			});
			this._calculateAllQuantities();
		}
	},
	_calculateAllQuantities: function() {
		this.set('gallons-walls', this._calculateInternalWallQuantity());
		this.set('gallons-doors', this._calculateDoorQuantity());
		this.set('gallons-ceiling', this._calculateCeilingQuantity());
		this.set('gallons-trim', this._calculateInternalTrimQuantity());
	},
	// All the math below this point is from Behr - this is how they requested our calculator work
	_rectifyTouchUpValue: function() {
		return this.get('touchUp') ? this.TOUCHUP_QTY_FACTOR : 1;
	},
	_rectifyVaultedValue: function() {
		return this.get('vaulted') ? this.VAULTED_CEILING_FACTOR : 1;
	},
	_rectifyWallHeightValue: function() {
		return this.get('vaulted') ? this.VAULTED_CEILING_HEIGHT : this.STANDARD_CEILING_HEIGHT;
	},
	_calculatePaintQuantity: function(elementQty) {
		const fractionalQty = elementQty - Math.floor(elementQty);
		let gallon = 0.0,
			quart = 0.0;
		if (fractionalQty > this.QUART_THRESHOLD) {
			gallon = Math.ceil(elementQty);
		} else if (fractionalQty > 0 || elementQty > 0) {
			gallon = Math.floor(elementQty);
			if (fractionalQty > 0.0) {
				quart = 1;
			}
		}
		// We do not sell quarts so must round up to gallon (quarts will only be 1 or 0)
		return gallon + (quart > 0 ? 1 : 0);
	},
	_calculateCeilingQuantity: function() {
		const vaulted = this._rectifyVaultedValue(),
			touchUp = this._rectifyTouchUpValue(),
			ceilingQty = (this.get('length') * this.get('width') * vaulted * touchUp) / this.SPREAD_RATE;
		return this._calculatePaintQuantity(ceilingQty);
	},
	_calculateDoorQuantity: function() {
		const touchUp = this._rectifyTouchUpValue(),
			doorsQty = (2.0 * this.get('doors') * this.DOOR_SURFACE_AREA * touchUp) / this.SPREAD_RATE;
		return this._calculatePaintQuantity(doorsQty);
	},
	_calculateInternalWallQuantity: function() {
		const wallHeight = this._rectifyWallHeightValue(),
			touchUp = this._rectifyTouchUpValue(),
			wallsQty =
				((2.0 * wallHeight * (this.get('length') + this.get('width')) -
					this.get('windows') * this.WINDOW_SURFACE_AREA -
					this.get('doors') * this.DOOR_SURFACE_AREA) *
					touchUp) /
				this.SPREAD_RATE;
		return this._calculatePaintQuantity(wallsQty);
	},
	_calculateInternalTrimQuantity: function() {
		const touchUp = this._rectifyTouchUpValue(),
			trimQty =
				((2 * (this.get('length') + this.get('width')) + this.get('windows') * this.WINDOW_PERIMETER) * touchUp) / this.SPREAD_RATE;
		return this._calculatePaintQuantity(trimQty);
	}
});
